export default "__VITE_PUBLIC_ASSET__8ab26e6e__"